export interface SessionTokenLike {
  accessToken?: string;
  token?: string;
  data?: {
    accessToken?: string;
    token?: string;
  };
}

export const formatCurrency = (value: number | string | null | undefined) => {
  const num = Number(value ?? 0);
  const safe = Number.isFinite(num) ? num : 0;
  return `$${safe.toLocaleString("en-US")}`;
};

export const getSessionToken = (session: SessionTokenLike | null | undefined) => {
  return (
    session?.accessToken ||
    session?.token ||
    session?.data?.accessToken ||
    session?.data?.token ||
    ""
  );
};

export const getBackendTimezone = () => {
  const rawTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata";
  const normalized = rawTimezone.toLowerCase();
  if (normalized === "asia/kolkata" || normalized === "asia/calcutta") {
    return "Asia/Kolkata";
  }
  return rawTimezone;
};

